import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThirdwebProvider, 
		 metamaskWallet, 
		 coinbaseWallet, 
		 walletConnect, 
		 rainbowWallet,
		 trustWallet,
		 zerionWallet,
		 phantomWallet 
	   } from "@thirdweb-dev/react";
import {myDAPPwalletConfig} from "mdw-ethers";	   
import "./styles/globals.css";
import { Toaster } from "./components/ui/Toaster";
import { getGasless } from "./utils/getGasless";
import {
  biconomyApiIdConst,
  biconomyApiKeyConst,
  relayerUrlConst,
  clientIdConst,
} from "./consts/parameters";



const container = document.getElementById("root");
const root = createRoot(container!);
const urlParams = new URL(window.location.toString()).searchParams;

const relayerUrl = urlParams.get("relayUrl") || relayerUrlConst || "";
const biconomyApiKey =
  urlParams.get("biconomyApiKey") || biconomyApiKeyConst || "";
const biconomyApiId =
  urlParams.get("biconomyApiId") || biconomyApiIdConst || "";
const sdkOptions = getGasless(relayerUrl, biconomyApiKey, biconomyApiId);

const activeChain = {
  // === Required information for connecting to the network === \\
  chainId: 8888, // Chain ID of the network
  // Array of RPC URLs to use
  rpc: ["https://u888.mydappwallet.com:8600"],

  // === Information for adding the network to your wallet (how it will appear for first time users) === \\
  // Information about the chain's native currency (i.e. the currency that is used to pay for gas)
  nativeCurrency: {
    decimals: 18,
    name: "Unity888",
    symbol: "U8"
  },
  shortName: "unity888", // Display value shown in the wallet UI
  slug: "unity888", // Display value shown in the wallet UI
  testnet: true, // Boolean indicating whether the chain is a testnet or mainnet
  chain: "Unity888", // Name of the network
  name: "Unity888 Testnet" // Name of the network
}

const clientId = urlParams.get("clientId") || clientIdConst || "";

root.render(
  <React.StrictMode>
    <ThirdwebProvider activeChain={activeChain} supportedWallets={[myDAPPwalletConfig(), metamaskWallet(), coinbaseWallet(), walletConnect(), rainbowWallet(), trustWallet(), zerionWallet(), phantomWallet()]} sdkOptions={sdkOptions} clientId={clientId}>
      <Toaster />
      <App />
    </ThirdwebProvider>
  </React.StrictMode>,
);
